/**
 * string with 1 or several words
 * @param {String} string
 * @returns {String} string with first letter capitalized for every word in the string
 */

export const capitalizeTheFirstLetterOfEachWord = (string: string) => {
  const separateWord = string.toLowerCase().split(' ')
  for (let i = 0; i < separateWord.length; i++) {
    separateWord[i] =
      separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1)
  }
  return separateWord.join(' ')
}
